import waitForChangeAndMutate from '@utils/user/waitForChangeAndMutate'

const waitForPacketChangeAndMutate = (props) =>
    waitForChangeAndMutate({ ...props, query: 'prepaid_ads' })

export default waitForPacketChangeAndMutate